export default __webpack_public_path__ + "static/media/classic.ddb0ed52.png";